export default function GNAddressFormat(addressObj) {
  const { city, country, postalCode, state, street } = addressObj

  let returnAddress = ''
  let spacer = ''

  if (street) {
    returnAddress = `${street}`
  }

  if (city) {
    const comma = street ? ', ' : ''
    returnAddress = `${returnAddress}${comma}${city}`
  }

  if (state) {
    spacer = returnAddress.length ? ', ' : ''
    returnAddress = `${returnAddress}${spacer}${state}`
  }

  if (country && country !== 'US') {
    spacer = returnAddress.length ? ' ' : ''
    returnAddress = `${returnAddress}${spacer}${country}`
  }

  if (postalCode) {
    spacer = returnAddress.length ? ' ' : ''
    returnAddress = `${returnAddress}${spacer}${postalCode}`
  }

  return returnAddress
}



// WEBPACK FOOTER //
// ./src/helpers/GNAddressFormat.js